import React from "react";

export default function SelectItemComponent({
  title,
  selected,
  onSelect,
  item,
  filterType,
  dark = false,
}) {
  const onClick = () => {
    onSelect(selected ? null : item, filterType, selected);
  };

  return (
    <button
      onClick={onClick}
      className={`flex flex-row items-center justify-between py-2 px-3 w-full rounded-lg transition-all duration-250 ${
        selected 
          ? "bg-secondary text-white font-semibold shadow-md shadow-secondary/15" 
          : dark 
            ? "hover:bg-secondary/10 hover:text-secondary text-zinc-300" 
            : "hover:bg-orange-50/50 hover:text-secondary text-gray-700"
      } !cursor-pointer`}
      aria-disabled="false"
    >
      <div className="select-none capitalize text-sm tracking-wide">
        {title}
      </div>
      {selected && (
        <span className="text-white text-xs font-bold">✓</span>
      )}
    </button>
  );
}

